<template>
  <a v-if="!isGlobal" :href="langJson[lang].linkUrl" class="header-link" target="_blank">
    <span>{{ langJson[lang].linkText }}</span>
    <span class="icon-arrow-next-small"></span>
  </a>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  const mainStore = useMainStore();
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);
  const isGlobal = computed(() => mainStore.isGlobal);
</script>
